<template>
  <div class="asc-feature-flags">
    <asc-switch v-model="fleetDataPage" label="Fleet Page"></asc-switch>
    <asc-switch v-model="flightDataPage" label="Flight Data Page"></asc-switch>
    <asc-switch
      v-model="maintenanceRecPage"
      label="Maintenance Rec Page"
    ></asc-switch>
    <asc-switch
      v-model="customAlertsPage"
      label="Custom Analytics"
    ></asc-switch>
    <asc-switch
      v-model="removalsTimeline"
      label="Removals Timeline"
    ></asc-switch>
    <asc-switch
      v-model="reportListAlertColumn"
      label="Report List Alert Column"
    ></asc-switch>
    <asc-switch
      v-model="reportListExport"
      label="Report List Export"
    ></asc-switch>
    <asc-switch
      v-model="reportDetailsExport"
      label="Report Details Export"
    ></asc-switch>
    <asc-switch v-model="reportPlots" label="Report Plots"></asc-switch>
    <asc-switch
      v-model="navGlobalFilterButton"
      label="Top Navbar Global Filter Button"
    ></asc-switch>
    <asc-switch
      v-model="navNotificationsButton"
      label="Top Navbar Notifications Button"
    ></asc-switch>
    <asc-switch v-model="eventReports" label="Event Reports"></asc-switch>

    <v-row no-gutters>
      <v-col cols="12" sm="12" md="2">
        <asc-switch
          v-model="subscriptionCenter"
          label="Subscription Center"
        ></asc-switch>
      </v-col>
      <v-col v-if="subscriptionCenter" cols="6" md="10">
        <v-slide-group multiple show-arrows>
          <v-slide-item
            v-for="subscription in subscriptions"
            :key="subscription.id"
          >
            <v-btn
              class="mx-1"
              :input-value="subscription.visible"
              depressed
              rounded
              active-class="primary"
              @click="toggleSubscriptions(subscription)"
            >
              {{ subscription.groupName.split('_').join(' ') }}
            </v-btn>
          </v-slide-item>
        </v-slide-group>
      </v-col>
    </v-row>
    <asc-switch
      v-model="advancedCustomAlerts"
      label="Advanced Custom Analytics"
    ></asc-switch>
    <asc-switch
      v-model="documentManagementPage"
      label="Document Management"
    ></asc-switch>
    <asc-switch
      v-model="derivedParameters"
      label="Custom Parameters"
    ></asc-switch>
    <asc-switch v-model="powerBiPage" label="Power BI Page"></asc-switch>
    <asc-switch
      v-model="anserToolPage"
      label="Analytics Developer Page"
    ></asc-switch>
    <asc-switch
      v-model="AOGFaultMgmtPage"
      label="Aog Fault Management Page"
    ></asc-switch>
  </div>
</template>

<script>
import AscSwitch from '@/components/atoms/AscSwitch'
import AppFeatureFlags from '@/utilities/appFeatureFlags'

export default {
  name: 'AscFeatureFlags',

  components: { AscSwitch },

  data() {
    return {
      customAlertsPage: AppFeatureFlags.getCustomAlertsPage(),
      documentManagementPage: AppFeatureFlags.getDocumentManagementPage(),
      eventReports: AppFeatureFlags.getEventReports(),
      fleetDataPage: AppFeatureFlags.getFleetDataPage(),
      fleetFaultMsgsTab: AppFeatureFlags.getFleetFaultMsgsTab(),
      fleetHealthScoreTab: AppFeatureFlags.getFleetHealthScoreTab(),
      flightDataPage: AppFeatureFlags.getFlightDataPage(),
      maintenanceRecPage: AppFeatureFlags.getMaintenanceRecPage(),
      navGlobalFilterButton: AppFeatureFlags.getNavGlobalFilterButton(),
      navNotificationsButton: AppFeatureFlags.getNavNotificationsButton(),
      removalsTimeline: AppFeatureFlags.getRemovalsTimeline(),
      reportDetailsExport: AppFeatureFlags.getReportDetailsExport(),
      reportListAlertColumn: AppFeatureFlags.getReportListAlertColumn(),
      reportListExport: AppFeatureFlags.getReportListExport(),
      subscriptionCenter: AppFeatureFlags.getSubscriptionCenter(),
      subscriptions: AppFeatureFlags.getSubscriptions(),
      reportPlots: AppFeatureFlags.getReportPlots(),
      advancedCustomAlerts: AppFeatureFlags.getAdvancedCustomAlerts(),
      derivedParameters: AppFeatureFlags.getDerivedParameters(),
      powerBiPage: AppFeatureFlags.getPowerBiPage(),
      anserToolPage: AppFeatureFlags.getAnserToolPage(),
      AOGFaultMgmtPage: AppFeatureFlags.getAOGFaultMgmtPage(),
    }
  },

  watch: {
    customAlertsPage(newValue) {
      AppFeatureFlags.setCustomAlertsPage(newValue)
    },
    documentManagementPage(newValue) {
      AppFeatureFlags.setDocumentManagementPage(newValue)
    },
    fleetDataPage(newValue) {
      AppFeatureFlags.setFleetDataPage(newValue)
    },
    fleetFaultMsgsTab(newValue) {
      AppFeatureFlags.setFleetFaultMsgsTab(newValue)
    },
    fleetHealthScoreTab(newValue) {
      AppFeatureFlags.setFleetHealthScoreTab(newValue)
    },
    flightDataPage(newValue) {
      AppFeatureFlags.setFlightDataPage(newValue)
    },
    maintenanceRecPage(newValue) {
      AppFeatureFlags.setMaintenanceRecPage(newValue)
    },
    navGlobalFilterButton(newValue) {
      AppFeatureFlags.setNavGlobalFilterButton(newValue)
    },
    navNotificationsButton(newValue) {
      AppFeatureFlags.setNavNotificationsButton(newValue)
    },
    removalsTimeline(newValue) {
      AppFeatureFlags.setrRemovalsTimeline(newValue)
    },
    reportListAlertColumn(newValue) {
      AppFeatureFlags.setReportListAlertColumn(newValue)
    },
    reportListExport(newValue) {
      AppFeatureFlags.setReportListExport(newValue)
    },
    reportDetailsExport(newValue) {
      AppFeatureFlags.setReportDetailsExport(newValue)
    },
    eventReports(newValue) {
      AppFeatureFlags.setEventReports(newValue)
    },
    subscriptionCenter(newValue) {
      AppFeatureFlags.setSubscriptionCenter(newValue)
    },
    reportPlots(newValue) {
      AppFeatureFlags.setReportPlots(newValue)
    },
    advancedCustomAlerts(newValue) {
      AppFeatureFlags.setAdvancedCustomAlerts(newValue)
    },
    derivedParameters(newValue) {
      AppFeatureFlags.setDerivedParameters(newValue)
    },
    powerBiPage(newValue) {
      AppFeatureFlags.setPowerBiPage(newValue)
    },
    anserToolPage(newValue) {
      AppFeatureFlags.setAnserToolPage(newValue)
    },
    AOGFaultMgmtPage(newValue) {
      AppFeatureFlags.setAOGFaultMgmtPage(newValue)
    },
  },

  methods: {
    toggleSubscriptions(subscription) {
      AppFeatureFlags.setSubscriptions(subscription)
    },
  },
}
</script>
